import { render, staticRenderFns } from "./tambahnews.vue?vue&type=template&id=82f3fafe&scoped=true&"
import script from "./tambahnews.vue?vue&type=script&lang=js&"
export * from "./tambahnews.vue?vue&type=script&lang=js&"
import style0 from "./tambahnews.vue?vue&type=style&index=0&id=82f3fafe&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f3fafe",
  null
  
)

export default component.exports